module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.routes), function(item) {
    return [(item.showOnly) ? _c('div', [_vm._l((item.children), function(child) {
      return (!child.hidden) ? [_c('router-link', {
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [(item.icon) ? _c('i', {
        class: item.icon
      }) : _vm._e(), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(child.name))])])], 1)] : _vm._e()
    })], 2) : _c('div', [(!item.noDropdown && !item.hidden) ? _c('el-submenu', {
      key: item.name,
      attrs: {
        "index": item.name
      }
    }, [_c('template', {
      slot: "title"
    }, [(item.icon) ? _c('i', {
      class: item.icon
    }) : _vm._e(), _vm._v(" "), _vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? [(child.children && child.children.length > 0) ? _c('sidebar-item', {
        key: child.name,
        staticClass: "menu-indent",
        attrs: {
          "routes": [child]
        }
      }) : _c('router-link', {
        key: child.name,
        staticClass: "menu-indent",
        attrs: {
          "to": item.path + '/' + child.path
        }
      }, [_c('el-menu-item', {
        attrs: {
          "index": item.path + '/' + child.path
        }
      }, [(child.icon) ? _c('i', {
        class: child.icon
      }) : _vm._e(), _vm._v(" "), _vm._v("\n                " + _vm._s(child.name) + "\n              ")])], 1)] : _vm._e()
    })], 2) : _vm._e()], 1)]
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b6fa7d1a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6fa7d1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/SidebarItem.vue
// module id = 320
// module chunks = 99